export const OFF_SERVER = "No se encuentra disponible el servidor";
export const OFF_SERVER_ERROR =
  "El servidor se encuentra en mantenimiento o está caido";
